/**
 * Takes a numerator and a denominator and converts it into a floated
 * percentage string. Accounts for situations where the denominator is null
 * or zero and returns "0.0".
 *
 * @param numerator
 * @param denominator
 */
export function formatPercent(
    numerator: number,
    denominator: number,
    decimals = 1
  ): string {
    if (denominator == null || denominator <= 0)
      return decimals === 0 ? '0' : '0.0';
  
    return ((numerator / denominator) * 100).toFixed(decimals);
  }